import { render, staticRenderFns } from "./detailDrawer.vue?vue&type=template&id=1f79fb0f&"
import script from "./detailDrawer.vue?vue&type=script&lang=js&"
export * from "./detailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./detailDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports